const state = {
  detailActive: false,
};

const mutations = {
  setDetailActive (state, value) {
    state.detailActive = value;
  },
  toggleDetailActive (state) {
    state.detailActive = !state.detailActive;
  },
};
const getters = {
  getDetailActive: state => state.detailActive,
};
const actions = {
  setDetailActive ({commit}, value) {
    commit ('setDetailActive', value);
  },
  toggleDetailActive({commit}) {
    commit ('toggleDetailActive');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
